// Public form submissions (no auth). Posts to the backend; unwraps error messages.
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

async function post(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error?.message || "Submission failed. Please try again.");
  return data;
}

export const submitContact = (payload) => post("/contact", payload);
export const submitApplication = (payload) => post("/applications", payload);
